<template>
  <v-dialog v-model="localDialog" width="35%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Role' : 'Update Role' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="CompnaySetup">
              <v-row>
                  <v-col cols="12">  
                    
                    <v-autocomplete
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="company_id.value.value"
                      :items="getCompanyList.filter(item=> item.status == 1)"
                      :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                      item-value="id"
                      :error-messages="company_id.errorMessage.value"
                      clearable        
                      autocomplete="off"
                    >
                      <template #label>
                        Company <span class="text-red-accent-4">*</span>
                      </template>
                    </v-autocomplete>  

                    <v-autocomplete
                      label="Branch"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="branch_id.value.value"
                      :items="getBranchList.filter(item => item.company_id == company_id.value.value)"
                      :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                      item-value="id"
                      :error-messages="branch_id.errorMessage.value"
                      clearable   
                      autocomplete="off"                     
                    >
                      <template #label>
                        Branch <span class="text-red-accent-4">*</span>
                      </template> 
                    </v-autocomplete> 


                      <v-text-field
                          label="Name"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="name.value.value"
                          :error-messages="name.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Name <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-textarea
                          label="Remarks (Optional)"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="remarks.value.value"
                          :error-messages="remarks.errorMessage.value"
                          clearable
                          auto-grow
                          rows="1"
                      ></v-textarea>
                      <v-autocomplete
                          label="Copy Role Permissions"
                          variant="outlined"
                          density="compact"
                          single-line
                          bg-color="grey-lighten-4"
                          v-model="copy_role_id.value.value"
                          :items="getRoleList.filter(item => item.branch_id == branch_id.value.value)"
                          :item-title="item => `${item.name} - ${item.code}`"                                                  
                          item-value="id"
                          :disabled="!isEntryMode"
                        ></v-autocomplete>

                        <v-checkbox                            
                          label="Active"
                          v-model="status.value.value"
                          :error-messages="status.errorMessage.value"
                          density="compact"
                          variant="outlined"
                          hide-details
                          single-line
                          color="primary"
                          value="1"
                      ></v-checkbox>
                                       
                  </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        name: '',
        remarks: '',
        status: '1',
        id: '',
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
    }
  },
  computed: {
     getRoleList() {
        return this.$store.getters.getRoleList;
     },
     getCompanyList() {
        return this.$store.getters.getCompanyList;
     },
     getBranchList() {
          return this.$store.getters.getBranchList;
     },
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || '', false);
        this.remarks.setValue(newData.remarks || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.role_id.setValue(newData.id || '', false);
        this.company_id.setValue(newData.branch.company_id || '', false);
        this.branch_id.setValue(newData.branch_id || '', false);

      },
      immediate: true
    },


    
  },
  created() {
    if(this.$store.getters.getCompanyList.length == 0){
        this.loading = true;
            this.$store.dispatch('getCompanyList').then((response) => {
            this.loading = false;
        })
    };
    if(this.$store.getters.getBranchList.length == 0){
        this.loading = true;
            this.$store.dispatch('getBranchList').then((response) => {
            this.loading = false;
        })
    };
  },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          branch_id: yup.number().positive().integer().required().label('Branch'),
          company_id: yup.number().positive().integer().required().label('Company'),
          name: yup.string().min(1).max(50).required().trim().label('Name'),
          remarks: yup.string().max(250).nullable().trim().label('Remarks'),
      }),

    });

    const company_id = useField('company_id');
    const branch_id = useField('branch_id');
    const name = useField('name');
    const copy_role_id = useField('copy_role_id');
    const status = useField('status');
    const role_id = useField('role_id');
    const remarks = useField('remarks');
    const errorMessages  = ref('');
    const loading  = ref('');
    const store = useStore();
    
    watch(() => branch_id.value.value, () => {
      copy_role_id.value.value = null;
    });

    const submit = handleSubmit((values) => {
        store.dispatch("saveUpdateRole", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getRoleList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);   
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      name,
      company_id,
      branch_id,
      copy_role_id,
      remarks,
      status,
      errorMessages,
      role_id,
      resetForm,
      loading
    }
  },
  mounted() {
    this.copy_role_id.value.value = null;
  }
}
</script>

